import { render, staticRenderFns } from "./addInvoice.vue?vue&type=template&id=618e7dac&scoped=true"
import script from "./addInvoice.vue?vue&type=script&lang=js"
export * from "./addInvoice.vue?vue&type=script&lang=js"
import style0 from "./addInvoice.vue?vue&type=style&index=0&id=618e7dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e7dac",
  null
  
)

export default component.exports